export const DEFAULT_INVALID_COLUMN_ERR =
  'One or more columns used in this widget are not available in the data source.';
